import API from "./API";

const GetUserNamesService = {
  async getAllBDPOCs(userId: number) {
    const response = await API().get("User/GetBDPOCs/" + userId, {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getAllBDHeads(userId: number) {
    const response = await API().get("User/GetBDHeads/" + userId, {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getAllSBUHeads(userId: number) {
    const response = await API().get("User/GetSBUHeads/" + userId, {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getAllSBGHeads(userId: number) {
    const response = await API().get("User/GetSBGHeads/" + userId, {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
};

export default GetUserNamesService;
